import React from "react";
import { Route, Redirect } from "react-router-dom";

/**
 * Component that protects route from unauthorized users.
 * @type {Function}
 */
export default ({
  component: Component,
  ...rest
}: {
  component: typeof React.Component;
}) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem("user") ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    }
  />
);
